(() => {
  const init = () => {
    const outletSource = document.querySelector('#topbar-selected-outlet');
    const outletLabel = document.querySelector('.home-header-outlet-label');
    if (outletSource && outletLabel && !outletLabel.dataset.homeOutletReady) {
      outletLabel.dataset.homeOutletReady = 'true';
      const updateOutlet = () => { outletLabel.textContent = outletSource.textContent.trim() || 'Select outlet'; };
      new MutationObserver(updateOutlet).observe(outletSource, { childList: true, characterData: true, subtree: true });
      updateOutlet();
    }
    const searchButton = document.querySelector('.home-mobile-search-trigger');
    const mobileSearch = document.querySelector('#home-mobile-search');
    if (searchButton && mobileSearch && !searchButton.dataset.homeSearchReady) {
      searchButton.dataset.homeSearchReady = 'true';
      searchButton.addEventListener('click', () => {
        const open = !mobileSearch.classList.contains('is-open');
        mobileSearch.classList.toggle('is-open', open);
        searchButton.setAttribute('aria-expanded', String(open));
        if (open) mobileSearch.querySelector('input[type="search"]')?.focus();
      });
      mobileSearch.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          mobileSearch.classList.remove('is-open');
          searchButton.setAttribute('aria-expanded', 'false');
          searchButton.focus();
        }
      });
    }
    const hero = document.querySelector('.template-index #MainContent > .slideshow');
    const heroTabs = hero?.querySelectorAll('.lavender-hero-tab');
    const heroCta = hero?.querySelector('.lavender-hero-cta');
    const products = document.querySelector('.template-index .lavender-home-bestsellers-backdrop');

    if (hero && heroTabs?.length && !hero.dataset.homeTabsReady) {
      hero.dataset.homeTabsReady = 'true';
      heroTabs.forEach((button) => {
        button.addEventListener('click', () => {
          const index = Number(button.dataset.slideIndex);
          const swiper = hero.querySelector('.swiper')?.swiper;
          if (swiper) swiper.slideToLoop(index);
        });
      });
      const connectHero = () => {
        const swiper = hero.querySelector('.swiper')?.swiper;
        if (!swiper) return false;
        const update = () => {
          heroTabs.forEach((button, index) => {
            const active = index === swiper.realIndex;
            button.classList.toggle('is-active', active);
            button.setAttribute('aria-pressed', String(active));
            if (active && heroCta) heroCta.href = button.dataset.slideLink;
          });
        };
        swiper.on('slideChange', update);
        update();
        return true;
      };
      if (!connectHero()) {
        let attempts = 0;
        const timer = setInterval(() => {
          attempts += 1;
          if (connectHero() || attempts >= 30) clearInterval(timer);
        }, 200);
      }
    }

    if (products && !products.dataset.homeControlsReady) {
      products.dataset.homeControlsReady = 'true';
      products.querySelector('.home-products-prev')?.addEventListener('click', () => {
        products.querySelector('.swiper')?.swiper?.slidePrev();
      });
      products.querySelector('.home-products-next')?.addEventListener('click', () => {
        products.querySelector('.swiper')?.swiper?.slideNext();
      });
      const connectProducts = () => {
        const swiper = products.querySelector('.swiper')?.swiper;
        if (!swiper) return false;
        const count = products.querySelector('.home-products-count');
        const total = Number(count?.textContent.match(/of\s+(\d+)/)?.[1]);
        const update = () => {
          if (!count || !total) return;
          const visible = Math.max(1, Math.floor(Number(swiper.params.slidesPerView) || 1));
          const start = swiper.realIndex + 1;
          count.textContent = `${start}–${Math.min(start + visible - 1, total)} of ${total}`;
        };
        swiper.on('slideChange', update);
        swiper.on('breakpoint', update);
        update();
        return true;
      };
      if (!connectProducts()) {
        let attempts = 0;
        const timer = setInterval(() => {
          attempts += 1;
          if (connectProducts() || attempts >= 30) clearInterval(timer);
        }, 200);
      }
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
